import React from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";

import CardTitleLoading from "./CardTitleLoading";

import styles from "./Card.module.css";

interface Props {
  hasCheckbox?: boolean;
  className?: string;
}

const CardLoading: React.FC<Props> = ({ hasCheckbox, className }) => {
  return (
    <div className={toClassName(styles.container, className)}>
      <div className={styles.body}>
        <div className={styles.top}>
          <CardTitleLoading />

          <Skeleton width={60} height={16} style={{ transform: "none" }} />
        </div>

        <div className={styles.bottom}>
          <div className={styles.flexRow}>
            <Skeleton width={90} height={24} style={{ transform: "none" }} />
          </div>

          <Skeleton width={90} height={20} style={{ transform: "none" }} />
        </div>
      </div>

      {hasCheckbox && (
        <div className={styles.checkboxContainer}>
          <Skeleton width={130} height={28} style={{ transform: "none" }} />
        </div>
      )}
    </div>
  );
};

export default CardLoading;
